import { valueReducer } from './utils'
import { Get } from '../actions/baselineShiftingEvents'
import { BaselineShiftingEvent } from '../types/baselineShiftingEvent'

export default valueReducer<BaselineShiftingEvent[]>(Get)
